module.exports = __webpack_public_path__ + "img/icon.2b9f788e.png";